const isObject = value => value !== null && typeof value === 'object' && !Array.isArray(value);

const isPageNumber = value => Number.isInteger(value) && value > 0;

export const isHighlightRecord = highlight => isObject(highlight) && (
  (typeof highlight.id === 'string' && highlight.id.trim().length > 0) ||
  (Number.isInteger(highlight.id) && highlight.id > 0)
);

const isScaledRect = rect => isObject(rect) &&
  ['x1', 'y1', 'x2', 'y2', 'width', 'height'].every(key => Number.isFinite(rect[key])) &&
  rect.width > 0 && rect.height > 0 &&
  (rect.pageNumber === undefined || isPageNumber(rect.pageNumber));

export const getHighlightValidationError = highlight => {
  if (!isHighlightRecord(highlight)) {
    return 'invalid_record';
  }

  const { position } = highlight;
  if (!isObject(position)) {
    return 'invalid_position';
  }
  if (!isPageNumber(position.pageNumber)) {
    return 'invalid_page_number';
  }
  if (!isScaledRect(position.boundingRect)) {
    return 'invalid_bounding_rect';
  }
  if (!Array.isArray(position.rects)) {
    return 'invalid_rects';
  }

  const hasImage = highlight.content &&
    typeof highlight.content.image === 'string' && highlight.content.image.length > 0;
  if (position.rects.length === 0 && !hasImage) {
    return 'missing_text_rects';
  }
  if (!position.rects.every(isScaledRect)) {
    return 'invalid_rect';
  }

  return null;
};

export const isRenderableHighlight = highlight => getHighlightValidationError(highlight) === null;

export const reportInvalidHighlight = highlight => {
  const reason = getHighlightValidationError(highlight);
  if (reason) {
    console.warn('Highlight overlay unavailable', {
      id: isHighlightRecord(highlight) ? highlight.id : null,
      reason,
    });
  }
};
